import {fillGDIResponsiveInheritance, parseGDIViewTypes} from '../optimizely/gdi/utils/gdi-styles'

/**
 * Convert a CMS stylesPerViewType array to Chakra UI responsive style props.
 */
export const convertCmsStyles = (stylesPerViewType) => {
    if (!stylesPerViewType?.length) return {}
    const allBreakpoints = ['base', 'md', 'lg']
    const webBreakpoints = new Set(allBreakpoints)
    const result = {}
    const set = (key, bp, val) => {
        const v = typeof val === 'string' ? val.trim() : val
        if (!v || v === 'Default / Inherit') return
        result[key] = result[key] || {}
        result[key][bp] = v
    }
    const parseBreakpoints = (viewTypes) =>
        parseGDIViewTypes(viewTypes).filter((bp) => webBreakpoints.has(bp))
    const applyEntry = ({TextAlignment, TextColor, BackgroundColor, FontStyle, FontSize, TextMaxWidth, Paddings, Margins}, breakpoints) => {
        breakpoints.forEach((bp) => {
            set('textAlign', bp, TextAlignment)
            set('color', bp, TextColor)
            set('bg', bp, BackgroundColor)
            set('fontStyle', bp, FontStyle)
            set('textStyle', bp, FontSize)
            set('maxWidth', bp, TextMaxWidth)
            set('padding', bp, Paddings)
            set('margin', bp, Margins)
        })
    }

    stylesPerViewType
        .filter((entry) => !entry?.ViewTypesToApply?.trim?.())
        .forEach((entry) => applyEntry(entry, allBreakpoints))

    stylesPerViewType
        .filter((entry) => entry?.ViewTypesToApply?.trim?.())
        .forEach((entry) => applyEntry(entry, parseBreakpoints(entry.ViewTypesToApply)))

    Object.keys(result).forEach((key) => {
        result[key] = fillGDIResponsiveInheritance(result[key])
    })

    return result
}

const PADDING_KEYS = ['p', 'pt', 'pb', 'pl', 'pr', 'px', 'py', 'padding', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingX', 'paddingY', 'paddingInline', 'paddingBlock']
const MARGIN_KEYS = ['m', 'mt', 'mb', 'ml', 'mr', 'mx', 'my', 'margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'marginX', 'marginY', 'marginInline', 'marginBlock']

/**
 * Merge theme styles with CMS styles, removing all Chakra/CSS spacing props
 * (both shorthands and longhands) from the theme when CMS provides margin/padding,
 * so theme spacing cannot bleed through.
 */
export const mergeWithCmsSpacing = (themeStyles, cmsStyles) => {
    const merged = {...themeStyles}
    if (cmsStyles.padding !== undefined) PADDING_KEYS.forEach(k => { delete merged[k] })
    if (cmsStyles.margin !== undefined) MARGIN_KEYS.forEach(k => { delete merged[k] })
    return {...merged, ...cmsStyles}
}
